import { useQuery } from '@tanstack/react-query';
import type { IPaginationParams } from 'v2/interfaces/pagination';
import productService from 'v2/services/product';

export const useListIrregularProducts = (pagination: IPaginationParams, search: string) => {
  const { data: response, isFetching } = useQuery({
    queryKey: ['irregularProducts', pagination.current_page, pagination.per_page, search],
    queryFn: () => productService.listIrregularProducts(pagination, search)
  });

  return {
    data: response?.data ?? [],
    pagination: response?.pagination,
    isFetching
  };
};
